import React, { useEffect, useRef } from 'react';
import { useAppSelector } from '../store/hooks';
import { practiceApiService } from '../services/practiceApiService';

const PracticeRecorder: React.FC = () => {
  const isPlaying = useAppSelector((state) => state.app.isPlaying);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const elapsedRef = useRef(0);

  useEffect(() => {
    if (!isAuthenticated || !isPlaying) {
      return;
    }

    const interval = setInterval(() => {
      elapsedRef.current += 1;
    }, 1000);

    return () => {
      clearInterval(interval);
      const seconds = elapsedRef.current;
      elapsedRef.current = 0;
      if (seconds >= 1) {
        practiceApiService.record(seconds).catch(() => {});
      }
    };
  }, [isPlaying, isAuthenticated]);

  return null;
};

export default PracticeRecorder;
